<template>
  <magic-card v-if="ContractsLicense"
              :title="$t('servicesystem.common_objects.machine.contract')"
              :icon="'$contract'"
              :fontsize="'h4'">
    <template v-slot:content>
      <MachineContractHoverCard :id="machineId" />
    </template>
  </magic-card>
</template>

<script>
import MagicCard from "@/views/layouts/SlottedCardSection.vue";
import MachineContractHoverCard from "@/views/job/newjob/cards/machines/MachineContractHoverCard.vue";

export default {
  name: "MachineContractCard",
  props: {
    machineId: Number,
  },
  components: {
    MagicCard,
    MachineContractHoverCard,
  },

  data() {
    return {
      loading: true,
      Contracts: null,
    };
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>